import { IModelDataV1 } from '@df/catalog/model';
import { ICmsModel } from '@icms/core/resource/model/icms-model';
import sortBy from 'lodash-es/sortBy';
import { ICmsModelResource } from './icms-model.resource';

export interface IModelWithPosition extends ICmsModel {
    id: number;
    data: IModelWithPositionData | undefined;
    rawData: IModelWithPositionData | undefined;
}

export interface IModelWithPositionData extends IModelDataV1 {
    position?: number;
    parent?: number;
}

export function sortByPosition<T extends IModelWithPosition = IModelWithPosition>(items: T[]): T[] {
    return sortBy(items, i => (typeof i.data?.position === 'undefined' ? Infinity : -i.data.position));
}

export function getNextPosition(resource: ICmsModelResource<IModelWithPosition, number>, parentId: number | undefined): number {
    const items = resource.getAllExisting().filter(i => (parentId ? i.data?.parent === parentId : !i.data?.parent));
    return Math.max(0, ...items.map(i => i.data?.position).filter(i => typeof i === 'number')) + 10;
}
